export const ADMINPOST_CREATE_ACTIONS = {
    ADMINPOST_REQUEST: "ADMINPOST_REQUEST",
    ADMINPOST_RESPONSE: "ADMINPOST_RESPONSE",
    ADMINPOST_ERROR: "ADMINPOST_ERROR",
  };
  

  export const ADMINPOST_LIST_ACTIONS = {
    ADMINPOST_LIST_REQUEST: "ADMINPOST_LIST_REQUEST",
    ADMINPOST_LIST_RESPONSE: "ADMINPOST_LIST_RESPONSE",
    ADMINPOST_LIST_ERROR: "ADMINPOST_LIST_ERROR",
  };

  
  export const ADMINPOST_EDIT_ACTIONS = {
    ADMINPOST_EDIT_REQUEST: "ADMINPOST_EDIT_REQUEST",
    ADMINPOST_EDIT_RESPONSE: "ADMINPOST_EDIT_RESPONSE",
    ADMINPOST_EDIT_ERROR: "ADMINPOST_EDIT_ERROR",
  };
  
   
  export const ADMINPOST_DELETE_ACTIONS = {
    ADMINPOST_DELETE_REQUEST: "ADMINPOST_DELETE_REQUEST",
    ADMINPOST_DELETE_RESPONSE: "ADMINPOST_DELETE_RESPONSE",
    ADMINPOST_DELETE_ERROR: "ADMINPOST_DELETE_ERROR",
  };
  
  